//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'BATiC',
  data() {
    return {
      defaultJson:{
        "Abdominal Pain": "腹痛",
        "White Blood Cell Count": "白细胞计数",
        "Intra-abdominal lesions very unlikely": "腹腔内病变可能极低",
        "Serum Lipase": "血清酯酶",
        "Signs of Peritoneal Irritation": "腹膜刺激征",
        "WBC": "WBC",
        "Serum ALT": "血清 ALT",
        "Serum Creatinine": "血肌酐",
        "Hemodynamic Instability": "血流动力学不稳定性",
        "Abnormal Abdo. Doppler US": "腹部多普勒超声异常",
        "Serum LDH": "血清 LDH",
        "Serum AST": "血清 AST"
      },
      form:{
        ast:'',
        alt:'',
        ldh:'',
        lipase:'',
        creat:'',
        wcc:'',
        abnormalDoppler:'0',
        abdoPain:'0',
        signsPeritoneal:'0',
        hemoInstability:'0',
      },
      UACresult:'--',
      hasScore:false,
      disabled:false,
      int_score:0
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.UACresult ='--'
        return '--'
      } else {
        // (abnormalDoppler * 4) + (abdoPain * 2) + (signsPeritoneal * 2) + (hemoInstability * 2) + (ast > 60 ? 2 : 0) + (alt > 25 ? 2 : 0) + (ldh > 330 ? 1 : 0) + (lipase > 30 ? 1 : 0) + (creat > 50 ? 1 : 0) + (wcc > 9.5 ? 1 : 0)

        let result = ( form.abnormalDoppler * 4) + (form.abdoPain * 2) + (form.signsPeritoneal * 2) + (form.hemoInstability * 2) + (form.ast > 60 ? 2 : 0) + (form.alt > 25 ? 2 : 0) + (form.ldh > 330 ? 1 : 0) + (form.lipase > 30 ? 1 : 0) + (form.creat > 50 ? 1 : 0) + (form.wcc > 9.5 ? 1 : 0)
        // abnormalDoppler ? 0 : (signsPeritoneal ? 0 : (hemoInstability ? 0 : (score <8 ? 1 : 0)))
        self.int_score = form.abnormalDoppler ? 0 : (form.signsPeritoneal ? 0 : (form.hemoInstability ? 0 : (result <8 ? 1 : 0)))
        
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/BATiC.vue